import { ssrApi } from 'api/ssr';
import { IBlogPost } from 'constants/types';
import { BlogAndNews } from 'components/template/blog-and-news';

const CATEGORY_PREVIEW_LIMIT = 8;

const toPostPreview = (post: IBlogPost): Partial<IBlogPost> => ({
  _id: post._id,
  slug: post.slug,
  type: post.type,
  title: post.title,
  imageUrl: post.imageUrl,
  category: post.category,
  commentsCount: post.commentsCount,
  last_modified: post.last_modified,
});

const toPostPreviews = (posts: IBlogPost[]) =>
  posts.map(toPostPreview) as IBlogPost[];

export default function BlogsAllTypes({
  blogs,
  news,
  rtpchecks,
  bigwins,
}: {
  blogs: IBlogPost[];
  news: IBlogPost[];
  rtpchecks: IBlogPost[];
  bigwins: IBlogPost[];
}) {
  return (
    <BlogAndNews
      blogs={blogs}
      news={news}
      rtpchecks={rtpchecks}
      bigwins={bigwins}
    />
  );
}

export async function getServerSideProps() {
  const { results: blogs } = await ssrApi.blog.list({
    type: 'blogs-and-news',
    category: 'blogs',
    limit: CATEGORY_PREVIEW_LIMIT,
  });

  const { results: news } = await ssrApi.blog.list({
    type: 'blogs-and-news',
    category: 'news',
    limit: CATEGORY_PREVIEW_LIMIT,
  });

  const { results: rtpchecks } = await ssrApi.blog.list({
    type: 'blogs-and-news',
    category: 'rtpchecks',
    limit: CATEGORY_PREVIEW_LIMIT,
  });

  const { results: bigwins } = await ssrApi.blog.list({
    type: 'blogs-and-news',
    category: 'bigwins',
    limit: CATEGORY_PREVIEW_LIMIT,
  });

  return {
    props: {
      blogs: toPostPreviews(blogs),
      news: toPostPreviews(news),
      rtpchecks: toPostPreviews(rtpchecks),
      bigwins: toPostPreviews(bigwins),
    },
  };
}
